import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectActiveSort, selectCurrentMode, selectModesForSwitcher } from '../../store/itinerary/itinerary.selectors'
import { resetActiveSort, setActiveSort } from '../../store/itinerary/itinerarySlice'
import { ReponseItineraireChoix } from '../analytics/analytics.constants'
import SVGIcon from '../svg/SVGIcon'
import s from './ModeSwitcher.less'
import ModeItem from './ModeItem'
import ModeSelector from './ModeSelector'
import { TAG_MULTIPATH_CTA } from '../analytics/analytics.tagids.constants'
import TagActionButton from '../genericComponents/TagActionButton'
import { useAction } from '../utils/react-redux'
import ItinerarySortNav from './ItinerarySortNav'
import sortIcon from './sort.svg'
import T from '../i18n/T'
import useEventCallback from '../utils/useEventCallback'
import { navigateToItineraryRoute, navigateToProvider } from '../../store/itinerary/itinerary.actions'
import { SORT_TYPES } from '../../store/itinerary/itinerary.constants'
import classnames from 'classnames'
import { PUB_TAG } from '../analytics/PublisherTagsService'

const ModeSwitcher = () => {
  const execNavigateToRoute = useAction(navigateToItineraryRoute)
  const execNavigateToProvider = useAction(navigateToProvider)
  const currentMode = useSelector(selectCurrentMode)
  const modes = useSelector(selectModesForSwitcher)
  const activeSort = useSelector(selectActiveSort)
  const dispatch = useDispatch()

  const sortButtonHandler = useEventCallback(() => {
    if (activeSort) {
      dispatch(resetActiveSort())
    } else {
      dispatch(setActiveSort(SORT_TYPES.duration))
    }
  }, [activeSort])

  return (
    <div className={s.root}>
      <div className={s.sliderLine}>
        <TagActionButton
          type={TAG_MULTIPATH_CTA}
          tagInfo={{
            tag: PUB_TAG.PUB_ATC_MULTIPATH_TRI_RESULTAT,
            libelle_CTA: 'trier'
          }}
          className={classnames(s.sortButton, activeSort && s.sortButtonActive)}
          onClick={sortButtonHandler}
        >
          <div className={s.sortButtonIcon}>
            <SVGIcon url={sortIcon} />
          </div>
          <div>
            <T id="itinerary.sort.label" />
          </div>
          <div className={s.highlighter} />
        </TagActionButton>
        <ModeSelector
          modes={modes}
          className={s.modeSelector}
          renderMode={({ id, routeId, label, provider, icon, time }) => {
            const selected = !activeSort && currentMode === id
            return (
              <span>
                <ModeItem
                  label={label}
                  selected={selected}
                  icon={icon}
                  description={time ? time.label : '- -'}
                  onClick={() => {
                    dispatch(resetActiveSort())
                    routeId
                      ? execNavigateToRoute({ provider, routeId }, { pageTagContext: ReponseItineraireChoix })
                      : execNavigateToProvider({ mode: id, provider }, { pageTagContext: ReponseItineraireChoix })
                  }}
                />
              </span>
            )
          }}
        />
      </div>
      {activeSort && <ItinerarySortNav />}
    </div>
  )
}

export default ModeSwitcher
